module.exports = __webpack_public_path__ + "static/media/IMG_7270_DxO.f4e08b36.jpg";